// extracted by mini-css-extract-plugin
export var dividerLine = "_9j-3";
export var itemImage = "_9j-9";
export var lightDivider = "_9j-4";
export var modalContent = "_9j-5";
export var modalContentCompact = "_9j-6";
export var productCard = "_9j-a";
export var productImage = "_9j-b";
export var productImageCompact = "_9j-7";
export var productImagePlaceholder = "_9j-c";
export var productImagePlaceholderCompact = "_9j-8";
export var progressBarBackground = "_9j-1";
export var progressBarContainer = "_9j-0";
export var progressBarFill = "_9j-2";